import React from 'react';
import InspectionBuilderPx from '../../../../tabs/inspectionBuilder/index.js';

const InspectionBuilderTab = () => {
  return <InspectionBuilderPx />;
};

export default InspectionBuilderTab;
